<template>
  <div class="app ui-kit">
    <!--component v-bind:is="layoutComponent"></component-->
    <router-view/>
    <!--Modal v-for="(event, index) in modals" v-bind="event" :key="index"/-->
    <div class="modal-backdrop hide">
    </div>
    <Modal v-for="(event, index) in modals" v-bind="event" :key="index"/>
  </div>
</template>
<script>
  import Vue from 'vue'
  import SimpleLayout from '@/layout/SimpleLayout.vue'
  import DefaultLayout from '@/layout/DefaultLayout.vue'
  import { extend } from 'vee-validate';
  import Vuex from 'vuex';
  import "@/assets/css/client.css";
  import "vue-multiselect/dist/vue-multiselect.min.css"
  import * as rules from 'vee-validate/dist/rules';
  import { localize } from 'vee-validate';
  import ko from 'vee-validate/dist/locale/ko.json';
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/locale/ko';
  import 'vue2-datepicker/index.css';
  import Modal from '@/components/common/Modal'
  import Highcharts, { data } from "highcharts";
  import HighchartsMore from 'highcharts/highcharts-more';
  import Stock from "highcharts/modules/stock";
  import HighchartsVue from "highcharts-vue";
  import exportingInit from "highcharts/modules/exporting";
  import offlineExporting from "highcharts/modules/offline-exporting";
  import dataInit from "highcharts/modules/data";
  Vue.use(Vuex);
  Vue.component('DatePicker', DatePicker);
  Highcharts.setOptions({
    lang: {
      decimalPoint: '.',
      thousandsSep: ','
    },
    time: {
      timezone: 'asia/seoul'
    },
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      shared: true
    },
  });
  Stock(Highcharts);
  dataInit(Highcharts);
  HighchartsMore(Highcharts);
  exportingInit(Highcharts);
  offlineExporting(Highcharts);
  Vue.use(HighchartsVue);
  Vue.prototype.$dataProvider = {};
  extend('min', {
    validate(value, args) {
      return value.length >= args.length;
    },
    params: ['length']
  });
  extend('phone', {
    validate(value) {
      var regExp = /^\+?\d{1,3}?\-?\d{2,3}\-?\d{3,4}\-?\d{4}$/;
      return regExp.test(value) ? true : '전화번호 형식이 올바르지 않습니다.';
    },
  });
  extend('required', {
    ...rules.required,
  });
  extend('email', {
    ...rules.email,
  });
  localize('ko', ko);
  export default {
    data () {
      return {
        modals : [],
        layoutComponent : null,
      }
    },
    watch:{
      $route(to) {

      }
    },
    components:{
      DefaultLayout,
      SimpleLayout,
      Modal,
    },
    created () {
      window.vue = this
      this.$root.$on("openModal", this.openModal)
      this.$root.$on("closeModalAll", this.closeModalAll)
      this.$root.$on('notify', this.notify)
      this.loadCodes();
    },
    mounted(){
      this.layoutComponent = SimpleLayout;
      //this.loadAssetType();
      //this.loadVisitStatus();
      setTimeout(()=>{
      },1000)
    },
    methods: {
      openModal (event) {
        let modalIndex = this.modals.length
        if (event.side) {
          this.modals.forEach((item, index) => {
            if(item.event.side) {
              modalIndex = index
            }
          })
        }
        this.modals[modalIndex] = event
        this.$forceUpdate()
      },
      closeModalAll () {
        this.modals = []
        this.$forceUpdate()
      },
      loadCodes() {
        var that = this;
        var list = ['asset', 'visitStatus', 'visitType', 'userLevel'];
        list.forEach((x)=>{
          this.$http.get('/api/public/'+ x)
                  .then((result) => {
                    var o = {};
                    o[x] = result.data;
                    that.$store.dispatch('dropdown/addDataprovider', o);
                  }).catch((e) =>{
            console.log(e);
          })
        })
      },
      /*
      loadAssetType() {
        var that = this;
        this.$http.get('/api/public/asset')
          .then((result) => {

            that.$store.dispatch('dropdown/addDataprovider', {asset: result.data});
            //Vue.prototype.$dataProvider.asset = result.data;

          }).catch((e) =>{
            console.log(e);
        })
      },
      loadVisitStatus(){
        var that = this;
        this.$http.get('/api/public/visitStatus')
          .then((result) => {

            that.$store.dispatch('dropdown/addDataprovider', {visitStatus: result.data});
            //Vue.prototype.$dataProvider.asset = result.data;

          }).catch((e) =>{
            console.log(e);
        })
      },
      loadVisitStatus(){
        var that = this;
        this.$http.get('/api/public/visitType')
          .then((result) => {

            that.$store.dispatch('dropdown/addDataprovider', {visitStatus: result.data});
            //Vue.prototype.$dataProvider.asset = result.data;

          }).catch((e) =>{
            console.log(e);
        })
      }
      */
    }
  }

</script>

<style lang="scss">
  @import '/dist/fonts/font.min.css';
  @import '/dist/css/bootstrap.min.css';
  @import '/dist/css/flatkit.min.css';
  @import '/dist/css/app.css';

  @import '@/assets/scss/override.scss';


  /*Date Picker 스타일 강제변경 */
  .calendar-input{
    width: 100%;
    color: #464a4c;
  }
  .mx-calendar-content .cell.active, .mx-table-date .today  {
    /*color: #fff;*/
    /*background-color: #14adea;*/
    color: #14adea;
    border-color: transparent;
    border-radius: 3px;
  }

  .mx-calendar-content .cell:hover {
    color: white;
    background-color: #14adea;
  }

  .mx-datepicker-body{
    color: #333;
  }

  .mx-table{
    border-collapse: separate;
    border-spacing: 6px;
  }

  .mx-calendar-content .cell.disabled {
    cursor: not-allowed;
    color: #ccc;
    background-color: #fff;
  }

  .mx-table td{
    min-width: 31px;
    padding: 5px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .mx-table-date td, .mx-table-date th {
    height: auto;
    font-size: 12px;
  }
  .mx-calendar-header{
    margin-bottom: 20px;
  }
  .mx-btn {
    color: #333;
  }

  /*.mx-btn-icon-double-left, .mx-btn-icon-double-right{*/
  /*display: none;*/
  /*}*/

  .mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {
    color: #333;
  }



  /*체크된거 disabled 되었을 떄 잘 안보여서 수정*/
  .md-check input[disabled]:checked+i:before {
    opacity: 0.5;
    background: #00c73c;
  }
</style>
